import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableService } from '../../../../core/components/table/table.service';
import { BomDetailsTableService } from './table.service';
import { TableComponent } from '../../../../core/components/table/table.component';
import { NetsuiteBom } from '../../../../api/netsuite/models/bom';

@Component({
  selector: 'app-bom-details-table',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    TableComponent,
  ],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.sass'],
  providers: [
    {
      provide: TableService,
      useClass: BomDetailsTableService,
    },
  ],
})
export class BomDetailsTableComponent implements OnInit {
  private readonly service = inject(TableService) as BomDetailsTableService;

  @Input() set list(val: NetsuiteBom[]) {
    console.log(val);
    this.service.list = val;
  }

  @Output() emitterChange = new EventEmitter<NetsuiteBom>();

  @Input() columns: string[];

  constructor() {}

  ngOnInit(): void {
    this.service.displayedColumns = this.columns;
  }

  onSortChange(sort: Sort): void {
    this.service.sort(sort);
  }

  validateBomLot(bomLot: NetsuiteBom): void {
    this.emitterChange.emit(bomLot);
  }
}
